export const templates = {
  "Staffing Collaboration": {
  "Initial": {
    "subject": "Looking for Staffing Collaboration Opportunity with KnackHook",
    "body": `
I am [SenderName] from KnackHook LLC. I hope you are doing well.<br/><br/>
{{AI_CONTENT}}<br/><br/>
At <strong>KnackHook</strong>, we share that same vision of delivering staffing services that go beyond the traditional model. To achieve this, we’ve developed our proprietary <strong>AI staffing platform – KnackHire</strong>, which enables us to streamline the entire recruitment lifecycle with speed, accuracy, and transparency.<br/><br/>
Here’s how KnackHire helps us differentiate:<br/>
- <strong>AI-Powered Screening</strong> – Accelerates candidate evaluation and submission, ensuring faster turnarounds.<br/>
- <strong>Visa & Authorization Validation</strong> – Every candidate’s status is verified before submission.<br/>
- <strong>Structured L1 Technical Screening</strong> – Each candidate answers 5 technical and 1–2 coding questions, recorded on video. These recordings, along with assessment details, are shared with clients for full transparency.<br/>
- <strong>Quality Over Volume</strong> – Our process reduces wasted interview cycles and ensures you see only strong, project-ready candidates.<br/><br/>

I’d be glad to share with you <strong>sample screening videos and our submission format</strong> (<a href="https://knackhire.azurewebsites.net/HomeViewPartialInterviewCompletedCandidateDetails?guid=ba9470bd-b609-4831-8fc8-dc7bae1d5d4f&detailsType=2&CountryID=2" target="_blank"><strong><u>AI Assessment</u></strong></a> 
and 
<a href="https://meeting.zoho.com/meeting/videoprv?recordingId=edc3cc91aae23ce3b4909ce689063a1ed602d90d6f68cd26da9f8dbb1fba6bb5&x-meeting-org=53692294" target="_blank"><strong><u>Screening Call</u></strong></a>)  so you can see firsthand how KnackHire improves the hiring process.<br/><br/>

It would be an honor to explore how KnackHook and [Company Name] could collaborate, combining your proven staffing leadership with our AI-driven approach to deliver even greater value to clients. Would you be open to a short call next week to discuss this further?<br/><br/>
`
  },
  "FollowUp-1": {
    "subject": "Following up on Staffing Collaboration Opportunity with KnackHook",
    "body": `
I hope you’re doing well and wanted to follow up on my earlier email regarding a potential collaboration between KnackHook and [Company Name].<br/><br/>
{{AI_CONTENT}}<br/><br/>

At KnackHook, transparency is at the core of how we operate. With our proprietary staffing platform, <strong>KnackHire</strong>, every candidate we submit is:<br/>
- <strong>AI-screened</strong> for technical and role alignment.<br/>
- <strong>Visa & authorization validated</strong> prior to submission.<br/>
- <strong>Technically assessed with recorded video responses</strong> to 5–7 domain-specific questions. e.g. (AI Assessment and Screening Call)<br/><br/>

This way, you not only receive profiles but also clear evidence of each candidate’s capability—saving time, reducing interview cycles, and improving hiring outcomes.<br/><br/>

I’d be glad to share a couple of sample videos and assessment formats so you can see firsthand how we bring transparency and efficiency into the staffing process.<br/><br/>

Would you be open to a quick call next week to explore how we can align KnackHook’s AI-driven staffing services with [Company Name]'s current needs?<br/><br/>

Looking forward to your thoughts.<br/><br/>
`
  },
  "FollowUp-2": {
    "subject": "Exploring AI-Driven Staffing Collaboration with KnackHook",
    "body": `

I hope this note finds you well.
{{AI_CONTENT}}<br/><br/>
I wanted to gently check back regarding my earlier emails about a potential collaboration between KnackHook and [Company Name].<br/><br/>

We’ve seen that many staffing leaders are now looking for <strong>ways to reduce hiring cycles while maintaining candidate quality</strong>—and that’s exactly where our proprietary AI platform, <strong>KnackHire</strong>, makes a difference.<br/><br/>

To recap, KnackHire ensures:<br/>
- <strong>AI-powered technical evaluations</strong> with recorded video responses.<br/>
- <strong>Full transparency</strong> in submissions (assessment reports + video links).<br/>
- <strong>Validated candidate status</strong> (visa, authorization, availability).<br/><br/>

This has helped our clients cut down <strong>30–40% of interview cycles</strong> while onboarding project-ready talent faster.<br/>
If there’s even a small pilot opportunity where we can showcase this process with [Company Name], I’d be glad to set it up.<br/><br/>

Would you be available for a quick discussion sometime this week or next?<br/><br/>

Looking forward to your response.<br/><br/>
`
  },
  "FollowUp-3": {
    "subject": "Last Attempt: Staffing Collaboration with KnackHook",
    "body": `
I realize you may be busy, so I’ll keep this short.
{{AI_CONTENT}}<br/><br/>
I’ve been reaching out regarding a possible collaboration between KnackHook and [Company Name].<br/><br/>

We strongly believe our <strong>AI-driven staffing approach</strong> can complement your delivery model, ensuring <strong>higher quality candidates, faster submissions, and complete transparency</strong> with every profile shared.<br/><br/>

Even if there isn’t an immediate need today, I’d love to stay in touch and be considered for future opportunities. I’d also be glad to send over <strong>a couple of sample candidate assessments</strong> so you can see the process in action.<br/><br/>

If you feel this could be worth exploring, please let me know a convenient time. Otherwise, I’ll respect your inbox and circle back later this year.<br/><br/>

Thank you for your time and consideration.<br/><br/>
KnackHire<br/>
KnackHire is an AI-powered, all-in-one staffing solution that streamlines job and candidate management, resume parsing, and AI-driven matching. It offers advanced video and coding assessments, subm...<br/><br/>
`
  }
},
  "Software Development": {
    Initial: {
      subject: "Exploring AI & Software Development Collaboration with KnackHook",
      body: `
I am [SenderName] from KnackHook LLC. I hope you are doing well.<br/><br/>

{{AI_CONTENT}}<br/><br/>

I wanted to reach out and explore how <strong>KnackHook</strong> could support your technology initiatives. 
Whether it’s <strong>taking up a full project/product development or outsourcing skilled technical resources</strong>, 
we provide flexible, cost-effective solutions delivered from <strong>our teams in the US and India</strong>.<br/><br/>

<strong>Our core capabilities include:</strong><br/>
- <strong>AI/ML Development </strong>– Agentic AI, Responsible AI, and custom AI solutions for business impact.<br/>
- <strong>Data Engineering & Analytics </strong>– Building scalable pipelines, dashboards, and actionable insights.<br/>
- <strong>Enterprise Application Development </strong> – Custom, cloud-native applications for business transformation.<br/>
- <strong>Mobile App Development </strong>– Native and cross-platform apps with engaging UX.<br/><br/>

With <strong>70+ technical resources</strong>, we can scale quickly to meet project requirements 
while offering<strong> affordable bill rates</strong> for outsourced teams.<br/><br/>

Would you be open to a brief call next week to explore collaboration opportunities?<br/><br/>
      `
    },
    "FollowUp-1": {
      subject: "Following up: AI & Software Development Collaboration with KnackHook",
      body: `

I wanted to follow up on my previous email regarding potential collaboration with <strong>KnackHook</strong>.<br/><br/>
{{AI_CONTENT}}<br/><br/>
We specialize in <strong>AI/ML development, data engineering, and enterprise application development</strong>, 
with strong expertise in <strong>Responsible AI and Agentic AI systems</strong>. Beyond project delivery, 
we can also <strong>provide dedicated technical resources on flexible and affordable bill rates</strong>, 
either onshore or offshore from India.<br/><br/>

Additionally, our teams deliver <strong>mobile app development</strong> and other full-stack solutions 
to support end-to-end software initiatives.<br/><br/>

I’d be happy to share <strong>case studies and examples</strong> of how we’ve helped other clients 
accelerate development timelines while optimizing costs.<br/><br/>

Would you have some time this week to discuss where <strong>KnackHook</strong> can add value?<br/><br/>
      `
    },
    "FollowUp-2": {
      subject: "Checking in: Software Development & AI/ML Collaboration",
      body: `

Just checking in regarding my earlier messages. 
{{AI_CONTENT}}<br/><br/>
At <strong>KnackHook</strong>, we help companies scale their technology initiatives efficiently, whether through <strong>full project/product development</strong>
or by <strong>outsourcing dedicated technical teams</strong> at competitive bill rates.<br/><br/>

<strong>Our focus areas:</strong><br/>
- <strong>AI/ML Development & Responsible AI </strong>– Driving intelligent, actionable solutions.<br/>
- <strong>Data Engineering & Analytics</strong> – Robust pipelines, dashboards, and insights.<br/>
- <strong>Enterprise Application Development</strong> – Modern, scalable applications.<br/>
- <strong>Mobile App Development </strong>– Engaging apps for web and mobile platforms.<br/><br/>

We provide <strong>US & India delivery models</strong> to ensure both speed and cost efficiency. 
Even a small pilot can showcase how <strong>KnackHook</strong> can accelerate your initiatives.<br/><br/>

Would you be open to a brief conversation this week?<br/><br/>
      `
    },
    "FollowUp-3": {
      subject: "Last Follow-Up: AI & Software Development with KnackHook",
      body: `
I know things can get busy, so I’ll keep this brief.
{{AI_CONTENT}}<br/><br/>
 At <strong>KnackHook</strong>, we deliver <strong>AI/ML,data engineering, enterprise apps, and mobile development</strong> services through 
<strong>onshore and offshore teams</strong>.<br/><br/>

Whether it’s <strong>handling complete project/product development</strong> or <strong>outsourcing 
technical resources at affordable rates</strong>, we’re equipped to provide 
high-quality, scalable solutions.<br/><br/>

If it helps, I’d be happy to share a <strong>sample engagement format</strong> or <strong>case study deck </strong>
so you can see our delivery approach and transparency in action.<br/><br/>

Would you like me to send that over?<br/><br/>

Thank you for your time.<br/><br/>
      `
    }
  },
    "Personal and Business Branding": {
    Initial: {
      subject: "Boost Your Branding on LinkedIn — Just $10 with KnackVibes",
      body: `
I am [SenderName] from KnackHook LLC. I hope you are doing well.<br/><br/>
{{AI_CONTENT}}<br/><br/>
I wanted to introduce you to <strong>KnackVibes</strong>, our AI-powered branding and social media automation tool designed to make <strong>LinkedIn engagement effortless and affordable</strong>.<br/><br/>

With KnackVibes, you can:<br/>
- Automate and schedule <strong>2–3 posts per week</strong> for just <strong>$10</strong>.<br/>
- Generate AI-crafted posts based on trending topics and your interests (you approve before publishing).<br/>
- Celebrate special days with <strong>Knack Moments</strong>.<br/>
- Run <strong>Knack Polls</strong> and <strong>Knack Challenges</strong> to drive engagement and interaction.<br/><br/>

This ensures your <strong>personal or business brand</strong> is always visible, active, and engaging—without you having to spend hours creating content.<br/><br/>

Would you be open to a quick call next week so I can show how KnackVibes works?<br/><br/>

      `
    },
    "FollowUp-1": {
      subject: "Following Up: Affordable Branding with KnackVibes",
      body: `
I wanted to follow up on my earlier email about <strong>KnackVibes</strong>, our AI-powered automation tool for LinkedIn branding.<br/><br/>
{{AI_CONTENT}}<br/><br/>
For just <strong>$10</strong>, you can have <strong>2–3 professional posts per week</strong> created and scheduled—helping you stay consistent, relevant, and visible to your audience.<br/><br/>

Plus, KnackVibes comes with:<br/>
- <strong>Knack Moments</strong> for occasion-based wishes.<br/>
- <strong>Knack Polls</strong> for community engagement.<br/>
- <strong>Knack Challenges</strong> for educational or habit-building campaigns.<br/><br/>

It’s one of the most <strong>cost-effective ways to enhance your brand presence</strong> online.<br/><br/>

Would you like me to share a couple of sample posts so you can see the style and quality?<br/><br/>


      `
    },
    "FollowUp-2": {
      subject: "Checking In: Branding for Just $10 with KnackVibes",
      body: `

Just checking in to see if you had a chance to review my earlier emails.<br/><br/>
{{AI_CONTENT}}<br/><br/>
Many of our users love KnackVibes because it:<br/>
- Delivers <strong>consistent branding</strong> with <strong>2–3 weekly posts</strong>.<br/>
- Costs only <strong>$10</strong>, making it extremely affordable.<br/>
- Includes engagement tools like <strong>Knack Moments, Polls, and Challenges</strong> to keep audiences active and connected.<br/><br/>

If you’re looking to <strong>strengthen your digital presence</strong> without spending too much time or budget, KnackVibes is built for you.<br/><br/>

Would you be interested if I send you a <strong>sample demo video</strong> of how it works?<br/><br/>

      `
    },
    "FollowUp-3": {
      subject: "Last Follow-Up: Affordable Branding with KnackVibes",
      body: `

I know things can get busy, so I’ll keep this short. This is my last follow-up regarding <strong>KnackVibes</strong>, our AI-driven social media automation platform.<br/><br/>
{{AI_CONTENT}}<br/><br/>
For just <strong>$10</strong>, you can get:<br/>
- <strong>2–3 AI-generated, scheduled posts every week.</strong><br/>
- Automated features like <strong>Knack Moments, Polls, and Challenges</strong>.<br/>
- A consistent, professional brand presence on LinkedIn with minimal effort.<br/><br/>

If staying visible and engaged online is a priority for you or your business, KnackVibes is a simple, affordable way to make it happen.<br/><br/>

Would you like me to send over a <strong>demo video + sample posts</strong> so you can see the value firsthand?<br/><br/>
      `
    }
  },

  "AI Development": {
    Initial: {
      subject: "Accelerating AI Innovation with KnackHook",
      body: `

I’m [SenderName] from <strong>KnackHook</strong>, where we help enterprises and startups accelerate their <strong>AI journey</strong> through a blend of expertise, innovation, and affordability.<br/><br/>
{{AI_CONTENT}}<br/><br/>
Our dedicated teams in the <strong>US and India</strong> specialize in:<br/>
- <strong>AI/ML Development</strong> – Building intelligent models and custom solutions for business impact.<br/>
- <strong>Responsible AI</strong> – Ensuring fairness, ethics, and transparency in AI-driven systems.<br/>
- <strong>Agentic AI Development</strong> – Creating autonomous, goal-driven AI agents that streamline workflows and decision-making.<br/><br/>

Whether you’re looking for <strong>end-to-end product development</strong> or need <strong>on-demand technical resources</strong> at affordable rates, we can integrate seamlessly with your teams.<br/><br/>

Would you be open to a quick call next week to explore how we could support your AI initiatives?<br/><br/>
      `
    },
    "FollowUp-1": {
      subject: "Following Up: AI/ML & Agentic AI Development Services",
      body: `
I wanted to follow up on my earlier email about how <strong>KnackHook</strong> supports companies with <strong>cutting-edge AI development</strong>.<br/><br/>
{{AI_CONTENT}}<br/><br/>
Our teams bring hands-on experience in:<br/>
- <strong>AI/ML Development</strong> – Custom model design, training, and deployment.<br/>
- <strong>Responsible AI</strong> – Frameworks and compliance to ensure trustworthy AI.<br/>
- <strong>Agentic AI</strong> – Next-gen systems that can act independently to automate workflows.<br/><br/>

With delivery centers in both <strong>US and India</strong>, we offer <strong>flexible engagement models</strong>—from full project delivery to contract staffing—ensuring cost-effective solutions without compromising quality.<br/><br/>

Would you like me to share a couple of <strong>case examples</strong> of how we’ve helped clients in this space?<br/><br/>
      `
    },
    "FollowUp-2": {
      subject: "Checking In: Responsible & Agentic AI Development",
      body: `
Just checking in to see if you had a chance to review my earlier messages.<br/><br/>
{{AI_CONTENT}}<br/><br/>
At <strong>KnackHook</strong>, we’re passionate about building <strong>scalable and responsible AI solutions</strong> that drive measurable business outcomes. From <strong>ML models</strong> that deliver insights, to <strong>agentic AI workflows</strong> that autonomously manage operations, we help organizations unlock new levels of efficiency.<br/><br/>

Our clients also appreciate that we can provide:<br/>
- <strong>End-to-end project ownership</strong>, or<br/>
- <strong>Dedicated technical resources</strong> at <strong>affordable bill rates</strong>.<br/><br/>

Would you be open to a short conversation to see if there’s alignment with your current or upcoming AI projects?<br/><br/>
      `
    },
    "FollowUp-3": {
      subject: "Final Follow-Up: Let’s Explore AI Development Collaboration",
      body: `

I know things can get busy, so I’ll keep this short. This is my final follow-up regarding <strong>AI development services</strong> from <strong>KnackHook</strong>.<br/><br/>
{{AI_CONTENT}}<br/><br/>
We can support you with:<br/>
- <strong>AI/ML Development</strong> for predictive analytics, automation, and personalization.<br/>
- <strong>Responsible AI</strong> practices for ethical, compliant systems.<br/>
- <strong>Agentic AI Development</strong> for autonomous decision-making and workflow automation.<br/><br/>

With 70+ skilled engineers across the <strong>US and India</strong>, we can either <strong>take up full projects</strong> or <strong>augment your team</strong> with expert resources at <strong>competitive rates</strong>.<br/><br/>

Would you like me to send over a <strong>capability deck</strong> to help you evaluate us as a potential partner?<br/><br/>
      `
    }
  }
};
